import { Component, CUSTOM_ELEMENTS_SCHEMA, Signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { PocketbaseService } from '../../services/pocketbase.service';

import '@material/web/fab/fab.js';
import '@material/web/icon/icon.js';
import '@material/web/ripple/ripple.js';

interface RailNavItem {
  activePrefixes: string[];
  href: string;
  icon: string;
  label: string;
}

@Component({
  selector: 'app-navigation-rail',
  imports: [RouterLink],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './navigation-rail.component.html',
  styleUrl: './navigation-rail.component.scss'
})
export class NavigationRailComponent {
  public readonly isLoggedIn: Signal<boolean>;
  public isExpanded = false;

  public readonly primaryItems: RailNavItem[] = [
    {
      activePrefixes: ['/'],
      href: '/',
      icon: 'home',
      label: 'Start'
    },
    {
      activePrefixes: ['/training'],
      href: '/training/all',
      icon: 'fitness_center',
      label: 'Training'
    },
    {
      activePrefixes: ['/kurse'],
      href: '/kurse',
      icon: 'school',
      label: 'Kurse'
    },
    {
      activePrefixes: ['/glossary'],
      href: '/glossary',
      icon: 'menu_book',
      label: 'Glossar'
    }
  ];

  public get mobileItems(): RailNavItem[] {
    return [...this.primaryItems, this.accountItem];
  }

  constructor(
    private readonly pocketbaseService: PocketbaseService,
    private readonly router: Router
  ) {
    this.isLoggedIn = this.pocketbaseService.loggedIn;
  }

  public get accountItem(): RailNavItem {
    if (this.isLoggedIn()) {
      return {
        activePrefixes: ['/profile'],
        href: '/profile',
        icon: 'account_circle',
        label: 'Profil'
      };
    }

    return {
      activePrefixes: ['/login', '/register', '/verify', '/reset-password'],
      href: '/login',
      icon: 'login',
      label: 'Login'
    };
  }

  public isRouteActive(item: RailNavItem): boolean {
    const currentUrl = this.router.url.split('?')[0];

    return item.activePrefixes.some((prefix) => {
      if (prefix === '/') {
        return currentUrl === '/';
      }

      return currentUrl === prefix || currentUrl.startsWith(`${prefix}/`);
    });
  }

  public logout(): void {
    this.pocketbaseService.logout();
  }

  public toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  public openAcademy(): void {
    window.open('https://knoot-academy.de/', '_blank', 'noopener,noreferrer');
  }
}
